import type {
  EmployerAgreementStatus,
  EmployerAgreementStatusInfo,
} from '@festina/life-general-types/life'
import { notEmpty, type Optional, type OptionalArray } from '@festina-life/core'

const EMPLOYER_AGREEMENT_STATUS_ORDER: Record<EmployerAgreementStatus, number> =
  {
    active: 0,
    future: 1,
    terminated: 2,
  }

const getStatusOrder = (status: Optional<EmployerAgreementStatus>): number =>
  notEmpty(status) && status in EMPLOYER_AGREEMENT_STATUS_ORDER
    ? EMPLOYER_AGREEMENT_STATUS_ORDER[status]
    : Number.MAX_SAFE_INTEGER

export const sortEmployerAgreementsByStatus = (
  employerAgreements: OptionalArray<EmployerAgreementStatusInfo>,
): EmployerAgreementStatusInfo[] =>
  [...(employerAgreements?.filter(notEmpty) ?? [])].sort(
    (statusInfoA, statusInfoB) =>
      getStatusOrder(statusInfoA.status) - getStatusOrder(statusInfoB.status),
  )
